import LayoutContentWrap from './contentWrap';

export default LayoutContentWrap;
